import type { ModePreset } from '@/common/store/pinia/appMode';
import type AcronisHttpAdapter from '@/common/utils/acronisHttpAdapter';

const buildGatewayHeaderFields = (api: AcronisHttpAdapter) => {
  const headers = api.getHeaders();
  return {
    'x-oagw-route': headers['X-OAGW-Route'] as string,
    'x-oagw-tenant': headers['X-OAGW-Tenant'] as string,
  };
};

export const buildAcronisWebsocketSettings = (
  api: AcronisHttpAdapter
): Pick<ModePreset, 'websocket'> => {
  const baseURL = api.getInstance().defaults?.baseURL ?? '';
  const gateway = buildGatewayHeaderFields(api);
  const authHeaders = api.getAuthorizationHeaders({});

  return {
    websocket: {
      wsUrl: `${baseURL}/ws`,
      vncWebSocketUrl: `${baseURL}/websockify`,
      queryParams: {
        ...gateway,
        'x-project-id': authHeaders['X-Auth-Token'],
      },
      headers: { ...gateway },
    },
  };
};
